import formatcoords from 'formatcoords';
export var locationDMS = function (entity) {
  return entity.latitude && entity.longitude && formatcoords(entity.latitude, entity.longitude).format('f', {
    decimalPlaces: 4
  });
};